// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/feather.eot?ue7xvz", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/feather.ttf?ue7xvz", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/feather.woff?ue7xvz", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("fonts/feather.svg?ue7xvz", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#feather" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'feather';
  src:  url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src:  url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('svg');
  font-weight: normal;
  font-style: normal;
}

[class^="ftr-"], [class*=" ftr-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'feather' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.ftr-edit2:before {
  content: "\\e937";
}
.ftr-blueprint-icon:before {
  content: "\\e912";
}
.ftr-arrow-down:before {
  content: "\\e900";
}
.ftr-arrow-up:before {
  content: "\\e901";
}
.ftr-codepen:before {
  content: "\\e902";
}
.ftr-copy:before {
  content: "\\e903";
}
.ftr-down:before {
  content: "\\e904";
}
.ftr-layers:before {
  content: "\\e905";
}
.ftr-left:before {
  content: "\\e906";
}
.ftr-more-vertical:before {
  content: "\\e907";
}
.ftr-right:before {
  content: "\\e908";
}
.ftr-settings:before {
  content: "\\e909";
}
.ftr-skip-forward:before {
  content: "\\e90a";
}
.ftr-trash:before {
  content: "\\e90b";
}
.ftr-up:before {
  content: "\\e90c";
}
.ftr-users:before {
  content: "\\e90d";
}
.ftr-wifi:before {
  content: "\\e90e";
}
.ftr-x:before {
  content: "\\e90f";
}
.ftr-alert-circle:before {
  content: "\\e913";
}
.ftr-alert-octagon:before {
  content: "\\e914";
}
.ftr-alert-triangle:before {
  content: "\\e915";
}
.ftr-align-center:before {
  content: "\\e916";
}
.ftr-align-justify:before {
  content: "\\e917";
}
.ftr-align-left:before {
  content: "\\e918";
}
.ftr-align-right:before {
  content: "\\e919";
}
.ftr-arrow-left:before {
  content: "\\e91a";
}
.ftr-arrow-right:before {
  content: "\\e91b";
}
.ftr-box:before {
  content: "\\e91c";
}
.ftr-cpu:before {
  content: "\\e91d";
}
.ftr-droplet:before {
  content: "\\e91e";
}
.ftr-edit:before {
  content: "\\e91f";
}
.ftr-external-link:before {
  content: "\\e920";
}
.ftr-file:before {
  content: "\\e921";
}
.ftr-flag:before {
  content: "\\e922";
}
.ftr-folder:before {
  content: "\\e923";
}
.ftr-grid:before {
  content: "\\e924";
}
.ftr-image:before {
  content: "\\e936";
}
.ftr-info:before {
  content: "\\e925";
}
.ftr-layout:before {
  content: "\\e926";
}
.ftr-loader:before {
  content: "\\e927";
}
.ftr-lock:before {
  content: "\\e928";
}
.ftr-monitor:before {
  content: "\\e929";
}
.ftr-octagon:before {
  content: "\\e92a";
}
.ftr-plus-circle:before {
  content: "\\e910";
}
.ftr-plus:before {
  content: "\\e938";
}
.ftr-star:before {
  content: "\\e92b";
}
.ftr-trash2:before {
  content: "\\e92c";
}
.ftr-triangle:before {
  content: "\\e92d";
}
.ftr-unlock:before {
  content: "\\e92e";
}
.ftr-user-minus:before {
  content: "\\e92f";
}
.ftr-user-plus:before {
  content: "\\e930";
}
.ftr-user:before {
  content: "\\e911";
}
.ftr-watch:before {
  content: "\\e931";
}
.ftr-x-circle:before {
  content: "\\e932";
}
.ftr-x-square:before {
  content: "\\e933";
}
.ftr-zap:before {
  content: "\\e934";
}
.ftr-zoom-out:before {
  content: "\\e935";
}
`, "",{"version":3,"sources":["webpack://./public/assets/feather.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,6CAAqC;EACrC;;;yDAGuD;EACvD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,+EAA+E;EAC/E,iCAAiC;EACjC,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;;EAEd,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB","sourcesContent":["@font-face {\n  font-family: 'feather';\n  src:  url('fonts/feather.eot?ue7xvz');\n  src:  url('fonts/feather.eot?ue7xvz#iefix') format('embedded-opentype'),\n    url('fonts/feather.ttf?ue7xvz') format('truetype'),\n    url('fonts/feather.woff?ue7xvz') format('woff'),\n    url('fonts/feather.svg?ue7xvz#feather') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n\n[class^=\"ftr-\"], [class*=\" ftr-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'feather' !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.ftr-edit2:before {\n  content: \"\\e937\";\n}\n.ftr-blueprint-icon:before {\n  content: \"\\e912\";\n}\n.ftr-arrow-down:before {\n  content: \"\\e900\";\n}\n.ftr-arrow-up:before {\n  content: \"\\e901\";\n}\n.ftr-codepen:before {\n  content: \"\\e902\";\n}\n.ftr-copy:before {\n  content: \"\\e903\";\n}\n.ftr-down:before {\n  content: \"\\e904\";\n}\n.ftr-layers:before {\n  content: \"\\e905\";\n}\n.ftr-left:before {\n  content: \"\\e906\";\n}\n.ftr-more-vertical:before {\n  content: \"\\e907\";\n}\n.ftr-right:before {\n  content: \"\\e908\";\n}\n.ftr-settings:before {\n  content: \"\\e909\";\n}\n.ftr-skip-forward:before {\n  content: \"\\e90a\";\n}\n.ftr-trash:before {\n  content: \"\\e90b\";\n}\n.ftr-up:before {\n  content: \"\\e90c\";\n}\n.ftr-users:before {\n  content: \"\\e90d\";\n}\n.ftr-wifi:before {\n  content: \"\\e90e\";\n}\n.ftr-x:before {\n  content: \"\\e90f\";\n}\n.ftr-alert-circle:before {\n  content: \"\\e913\";\n}\n.ftr-alert-octagon:before {\n  content: \"\\e914\";\n}\n.ftr-alert-triangle:before {\n  content: \"\\e915\";\n}\n.ftr-align-center:before {\n  content: \"\\e916\";\n}\n.ftr-align-justify:before {\n  content: \"\\e917\";\n}\n.ftr-align-left:before {\n  content: \"\\e918\";\n}\n.ftr-align-right:before {\n  content: \"\\e919\";\n}\n.ftr-arrow-left:before {\n  content: \"\\e91a\";\n}\n.ftr-arrow-right:before {\n  content: \"\\e91b\";\n}\n.ftr-box:before {\n  content: \"\\e91c\";\n}\n.ftr-cpu:before {\n  content: \"\\e91d\";\n}\n.ftr-droplet:before {\n  content: \"\\e91e\";\n}\n.ftr-edit:before {\n  content: \"\\e91f\";\n}\n.ftr-external-link:before {\n  content: \"\\e920\";\n}\n.ftr-file:before {\n  content: \"\\e921\";\n}\n.ftr-flag:before {\n  content: \"\\e922\";\n}\n.ftr-folder:before {\n  content: \"\\e923\";\n}\n.ftr-grid:before {\n  content: \"\\e924\";\n}\n.ftr-image:before {\n  content: \"\\e936\";\n}\n.ftr-info:before {\n  content: \"\\e925\";\n}\n.ftr-layout:before {\n  content: \"\\e926\";\n}\n.ftr-loader:before {\n  content: \"\\e927\";\n}\n.ftr-lock:before {\n  content: \"\\e928\";\n}\n.ftr-monitor:before {\n  content: \"\\e929\";\n}\n.ftr-octagon:before {\n  content: \"\\e92a\";\n}\n.ftr-plus-circle:before {\n  content: \"\\e910\";\n}\n.ftr-plus:before {\n  content: \"\\e938\";\n}\n.ftr-star:before {\n  content: \"\\e92b\";\n}\n.ftr-trash2:before {\n  content: \"\\e92c\";\n}\n.ftr-triangle:before {\n  content: \"\\e92d\";\n}\n.ftr-unlock:before {\n  content: \"\\e92e\";\n}\n.ftr-user-minus:before {\n  content: \"\\e92f\";\n}\n.ftr-user-plus:before {\n  content: \"\\e930\";\n}\n.ftr-user:before {\n  content: \"\\e911\";\n}\n.ftr-watch:before {\n  content: \"\\e931\";\n}\n.ftr-x-circle:before {\n  content: \"\\e932\";\n}\n.ftr-x-square:before {\n  content: \"\\e933\";\n}\n.ftr-zap:before {\n  content: \"\\e934\";\n}\n.ftr-zoom-out:before {\n  content: \"\\e935\";\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
